import appCaptainAppVersions from "../../views/appSettings/captainAppVersionsView.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "captain-app-versions";
  const params = ["page", "limit"];

  $stateProvider.state("captainappversions", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appCaptainAppVersions,
      },
    },
    reloadOnSearch: false,
    data: { title: "CaptainAppVersions" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/captainAppVersions/captainAppVersions.urls.js